import { TextField } from "@mui/material";
import { InputControl } from "../../../shared";

export const AddRoleDialog = ({ onChange, state, options, validator }) => {
  return (
    <div style={{ paddingTop: "16px", height: "100px", paddingInline: "16px" }}>
      <InputControl
        required
        sx={{
          width: "100%",
        }}
        type="dropdown"
        disableClearable
        options={options ?? []}
        getOptionLabel={(option) => option?.display_name}
        value={
          (options?.length > 0 &&
            state?.editData?.role_id &&
            options?.find((c) => c.id === state?.editData?.role_id)) ||
          null
        }
        onChange={(e, newValue) => {
          onChange({
            target: {
              name: "role_id",
              value: newValue?.id,
            },
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Role"
            required
            error={validator.current.message(
              "Role",
              state?.editData?.role_id,
              "required"
            )}
            helperText={validator.current.message(
              "Role",
              state?.editData?.role_id,
              "required"
            )}
          />
        )}
      />
    </div>
  );
};
